/* HERO CALC END */
let resizeTimeout;
  document.addEventListener('DOMContentLoaded', function() {
    const isCart = window.location.href.includes('cart') || window.location.href.includes('products');
    setProdSize();
    observeAddToOrderBtn();

    if (!isCart) {
      hideSpecificElements();
      deleteOldestRecordIfNeeded('kl-onsite-modules', 'kl-event-cache', 10);
    }
  });

window.addEventListener('load', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(setProdSize, 100);
});


window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(setProdSize, 100);
});


function setProdSize() {
  const elements = document.querySelectorAll('.prod-size');
  elements.forEach(element => {
    const width = element.getBoundingClientRect().width;
    const currentHeight = parseFloat(getComputedStyle(element).height);

    if (currentHeight !== width) {
      element.style.height = `${width}px`;
    }
  });
}

function observeAddToOrderBtn() {
  const observer = new MutationObserver((mutations, observer) => {
    const addToOrderBtn = document.getElementById('add_to_orderno');
    
    if (addToOrderBtn) {
      addToOrderBtn.addEventListener('click', async function () {
        const orderno = document.getElementById('orderno').value;
        const updateData = {
          updates: {
            12733761028173: orderno && !addToOrderBtn.classList.contains('existing') ? 1 : 0
          }
        };

        const maxRetries = 3;
        const retryDelay = 1000;

        async function fetchWithRetries(url, options, retries = maxRetries) {
          try {
            const response = await fetch(url, options);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          } catch (error) {
            if (retries > 0) {
              console.warn(`Fetch failed, retrying in ${retryDelay}ms...`, error);
              await new Promise(resolve => setTimeout(resolve, retryDelay));
              return fetchWithRetries(url, options, retries - 1); // Retry recursively
            } else {
              throw error; // No retries left, throw error
            }
          }
        }

        try {
          const responseData = await fetchWithRetries(ShopRoutes("cart_update_url", ".js"), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updateData)
          });

          if (orderno && !addToOrderBtn.classList.contains('existing')) {
            document.cookie = `order_number=${orderno}; path=/;`;
          }

          location.reload();
        } catch (error) {
          console.error('Error updating cart after retries:', error);
        }
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}


// Keeps Klaviyo's own IndexedDB cache small. The database and its object store belong to Klaviyo's onsite script:
// we never create or upgrade them here. If the database does not exist yet (open() would create an empty v1
// database and break Klaviyo's own setup) or the store is missing, there is nothing to trim.
function deleteOldestRecordIfNeeded(dbName, storeName, maxRecords) {
    if (!window.indexedDB) return;
    var request;
    try { request = indexedDB.open(dbName); } catch (e) { return; }

    request.onupgradeneeded = function (event) {
        // the database did not exist: abort so we do not leave an empty one behind
        try { event.target.transaction.abort(); } catch (e) { /* ignore */ }
    };

    request.onsuccess = function (event) {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(storeName)) { db.close(); return; }
        let store;
        try {
            const transaction = db.transaction(storeName, 'readwrite');
            transaction.oncomplete = function () { db.close(); };
            transaction.onerror = transaction.onabort = function () { db.close(); };
            store = transaction.objectStore(storeName);
        } catch (e) { db.close(); return; }
        const countRequest = store.count();

        countRequest.onsuccess = function () {
            if (countRequest.result > maxRecords) {
                const cursorRequest = store.openCursor(null, 'next');

                cursorRequest.onsuccess = function (event) {
                    const cursor = event.target.result;
                    if (cursor) {
                        store.delete(cursor.key);
                    }
                };
            }
        };

        countRequest.onerror = function () {
            console.error("Failed to count records:", countRequest.error);
        };
    };

    request.onerror = function () { /* blocked or unavailable (private mode): nothing to do */ };
}

function hideSpecificElements() {
    const sitesToHide = ['mygreetings'];
    const url = window.location.href;
    const shouldHide = sitesToHide.some(value => url.endsWith(value))
    const logoCarousel = document.getElementById('shopify-section-logo-carousel');
    if(logoCarousel && shouldHide) {
        logoCarousel.style.display = 'none';
    }

    const ctaElement = document.getElementById('shopify-section-CTA-myselfie');
    if(ctaElement) {
      ctaElement.style.display = 'none';
    }
}

window.addEventListener('load', function() {
  (function() {    
    var inputList = document.querySelectorAll('input[name="return_to"]');
    
    if (inputList.length > 0) {

      if (window.location) {
        if (window.location.search) {
          if (window.location.search.length > 0) {
            inputList.forEach(function(item) {

              var oldText = item.value;

              item.value = oldText + window.location.search; 
            });
          }
        }
      }
    }
  })();
});